import { Box, CardActions, Stack } from '@mui/material';

const variants = {
	default: {
		card: {
			p: 0,
			mb: '25px',
			pt: '20px',
			top: '64px',
			mt: '-20px',
			border: 'none',
			zIndex: 999,
			display: 'block',
			position: 'sticky',
			bgcolor: 'background.default',
		},
		box: { width: '100%' },
		stack: {
			py: '10px',
			// px: '0',
			px: '10px',
			height: '48px',
			borderRadius: '8px',
			position: 'relative',
			color: 'common.white',
			// bgcolor: 'header.background.primary',
			background: 'linear-gradient(90deg, #1447E6 1.44%, #155DFC 51.45%)',

			// bgcolor: 'transparent',
			padding: '12px 20px',
		},
	},
	inbox: {
		card: {
			//  mb: 0,
			mb: '25px',
		},
	},
	module: {
		card: { display: 'block' },
		stack: { borderBottomLeftRadius: '0', borderBottomRightRadius: '0' },
	},
	control: {
		stack: { borderBottomLeftRadius: '0', borderBottomRightRadius: '0' },
	},
	cascade: {
		stack: { borderBottomLeftRadius: '0', borderBottomRightRadius: '0' },
	},
	dochub: {
		stack: { borderBottomLeftRadius: '0', borderBottomRightRadius: '0' },
	},
	comptroller: {
		stack: { borderBottomLeftRadius: '0', borderBottomRightRadius: '0', padding: '10px 20px' },
	},
	identity: {
		card: { marginBottom: 0 },
		stack: { borderBottomLeftRadius: '0', borderBottomRightRadius: '0', height: '48px' },
	},
	dynamicForm: {
		card: { pt: '0px', top: '0px', display: 'block' },
		box: { borderRadius: 1 },
		stack: {
			px: '15px',
			py: '12px',
			borderRadius: '8px 8px 0 0',
		},
	},
};

const HeaderContainer = ({ variant = 'default', headerContent, children }) => {
	const styles = {
		card: { ...variants.default.card, ...variants[variant]?.card },
		box: { ...variants.default.box, ...variants[variant]?.box },
		stack: { ...variants.default.stack, ...variants[variant]?.stack },
	};

	return (
		<CardActions
			sx={{
				...styles.card,

				'& .MuiBox-root': {
					marginLeft: 0,
				},
			}}
		>
			<Box sx={{ ...styles.box }}>
				<Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ ...styles.stack }}>
					{headerContent}
				</Stack>
			</Box>

			{children}
		</CardActions>
	);
};

export default HeaderContainer;
